import { render, staticRenderFns } from "./DashboardNewApplicants.vue?vue&type=template&id=54860614&"
import script from "./DashboardNewApplicants.vue?vue&type=script&lang=js&"
export * from "./DashboardNewApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports